import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/esnext.string.replace-all.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.map.js";
// @ts-strict
import React from 'react';
import styled from 'styled-components';

/**
 * Muted background
 */
var Mark = styled.mark.withConfig({
  displayName: "highlight__Mark",
  componentId: "sc-e7l1x4-0"
})(["background-color:#fff8c5;"]);

/**
 * Highlight the text based on the search term
 * Splits the text up into fragments and wraps the search term in a mark tag
 * @param text - The text to highlight
 * @param highlights - The search term to highlight
 * @returns The highlighted text
 */
export function highlightText(text, highlights) {
  if (!highlights || !text) {
    return text;
  }
  var fragments = [];
  var reg = new RegExp("(".concat(highlights.replaceAll(/\s+/g, '|'), ")"), 'i');
  var match;
  var left;
  var right = text;
  while (match = right.match(reg)) {
    var m = match[0];
    var i = match.index;
    left = right.slice(0, i);
    right = right.slice(i + m.length);
    fragments.push(left);
    fragments.push( /*#__PURE__*/React.createElement(Mark, null, m));
  }
  if (right.length) {
    fragments.push(right);
  }
  return fragments.map(function (fragment, index) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: index
    }, fragment);
  });
}